import React from 'react'
import Colors from "../../config/colors";
import {RENTAL_STATUS} from '../../metadata/enums'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';


const PageHeader = ({header, subHeader, reservation}) => {
	return (
		<div>
			<p style={{color: Colors.primaryTextColor, fontWeight: 'bold', fontSize: 24, padding: '10px 0px'}}>{header}</p>
		</div>
	)
}

export default PageHeader
